import { PreheatInfo } from "@/pages/live/types/types";
import React from "react";
import styles from "./index.module.scss";



interface HeaderProps {
  preheatInfo: PreheatInfo;
  onShare?: () => void;
}

const Header: React.FC<HeaderProps> = ({ preheatInfo, onShare }) => {

  return (
    <div className={styles.headerWrap}>
      <p className={styles.title}>
        {preheatInfo.liveTitle}
      </p>
      <div className={styles.shareWrap} onClick={ onShare}>
        <img
          className={styles.icon}
          src="https://akmer.aikucun.com/47b78e45bd6e3aaabe2c64ef9945bbb7e9abe308_1602231698528_88.png"
          alt="share icon"
        />
        <p className={styles.txt}>转发</p>
      </div>
    </div>
  );
};

export default Header;
